import React, { useEffect, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'Sarah M.',
  location: 'Austin, TX',
  text: "I inherited a house that needed $40k in repairs. I didn't have the money or time. Nationwide Home Buyers made me a fair offer the next day and we closed in two weeks. So incredibly easy.",
  rating: 5
}, {
  id: 2,
  name: 'David & Lisa R.',
  location: 'Denver, CO',
  text: 'We were facing foreclosure and felt completely stuck. They stepped in, bought the house for cash, and saved our credit. They treated us with respect throughout the entire process.',
  rating: 5
}, {
  id: 3,
  name: 'James T.',
  location: 'Atlanta, GA',
  text: 'I needed to relocate for work within 30 days. Traditional agents told me it was impossible. These guys bought my house as-is and let me leave all my old furniture behind.',
  rating: 5
}, {
  id: 4,
  name: 'Maria G.',
  location: 'Phoenix, AZ',
  text: 'After dealing with terrible tenants who trashed my rental property, I just wanted out. The team gave me a fair price and handled the eviction process. A huge weight off my shoulders.',
  rating: 5
}];
export function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [isPaused, setIsPaused] = useState(false);
  useEffect(() => {
    if (isAutoPlaying && !isPaused) {
      const interval = setInterval(() => {
        setActiveIndex(current => (current + 1) % testimonials.length);
      }, 6000); // Increased to 6s
      return () => clearInterval(interval);
    }
  }, [isAutoPlaying, isPaused]);
  const prev = () => {
    setActiveIndex(current => current === 0 ? testimonials.length - 1 : current - 1);
  };
  const next = () => {
    setActiveIndex(current => (current + 1) % testimonials.length);
  };
  return <section className="py-20 md:py-28 px-6 md:px-12 lg:px-16 bg-slate-50 overflow-hidden" data-id="element-280">
      <div className="max-w-7xl mx-auto" data-id="element-281">
        <div className="text-center mb-16" data-id="element-282">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F172A] mb-6 tracking-tight" data-id="element-283">
            Real Stories from Real Sellers
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-284">
            Don't just take our word for it. See what homeowners have to say
            about their experience working with us.
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto" data-id="element-285">
          {/* Main Testimonial Card */}
          <div className="overflow-hidden rounded-2xl shadow-sm bg-white border-l-4 border-[#D4A24C] relative" data-id="element-286">
            <div className="flex transition-transform duration-500 ease-in-out" style={{
            transform: `translateX(-${activeIndex * 100}%)`
          }} data-id="element-287">
              {testimonials.map(testimonial => <div key={testimonial.id} className="w-full shrink-0 p-8 md:p-12 lg:p-16 relative" data-id="element-288">
                  <div className="absolute top-8 left-8 md:top-12 md:left-12 text-8xl font-serif text-[#D4A24C]/10 leading-none select-none pointer-events-none" data-id="element-289">
                    "
                  </div>
                  <p className="text-2xl md:text-3xl text-[#0F172A] leading-relaxed font-light mb-10 text-center md:text-left relative z-10" data-id="element-290">
                    {testimonial.text}
                  </p>

                  <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-6" data-id="element-291">
                    <div className="flex items-center gap-4" data-id="element-292">
                      <div className="w-14 h-14 bg-slate-100 rounded-full flex items-center justify-center text-xl font-bold text-slate-400" data-id="element-293">
                        {testimonial.name.charAt(0)}
                      </div>
                      <div className="text-center md:text-left" data-id="element-294">
                        <h4 className="text-lg font-bold text-[#0F172A]" data-id="element-295">
                          {testimonial.name}
                        </h4>
                        <p className="text-slate-500 text-sm" data-id="element-296">
                          {testimonial.location}
                        </p>
                      </div>
                    </div>
                    <div className="flex text-[#D4A24C] text-sm tracking-widest" data-id="element-297">
                      {'★'.repeat(testimonial.rating)}
                    </div>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Navigation Controls */}
          <button onClick={prev} className="hidden md:flex absolute top-1/2 -left-6 -translate-y-1/2 w-12 h-12 rounded-full bg-white shadow-md items-center justify-center text-[#0F172A] hover:bg-slate-50 hover:scale-105 transition-all z-20" aria-label="Previous testimonial" data-id="element-298">
            <ChevronLeftIcon className="w-6 h-6" data-id="element-299" />
          </button>
          <button onClick={next} className="hidden md:flex absolute top-1/2 -right-6 -translate-y-1/2 w-12 h-12 rounded-full bg-white shadow-md items-center justify-center text-[#0F172A] hover:bg-slate-50 hover:scale-105 transition-all z-20" aria-label="Next testimonial" data-id="element-300">
            <ChevronRightIcon className="w-6 h-6" data-id="element-301" />
          </button>

          {/* Dots */}
          <div className="flex justify-center gap-3 mt-8" data-id="element-302">
            {testimonials.map((_, idx) => <button key={idx} onClick={() => {
            setIsAutoPlaying(false);
            setActiveIndex(idx);
          }} className={`rounded-full transition-all duration-300 ${activeIndex === idx ? 'bg-[#D4A24C] w-3 h-3' : 'bg-slate-300 w-2.5 h-2.5 hover:bg-slate-400'}`} aria-label={`Go to testimonial ${idx + 1}`} data-id="element-303" />)}
          </div>

          {/* Progress Bar (visual indicator of autoplay) */}
          <div className="max-w-xs mx-auto mt-6 h-1 bg-slate-200 rounded-full overflow-hidden" data-id="element-304">
            {isAutoPlaying && <div className="h-full bg-[#D4A24C] animate-progress" key={activeIndex} // Force re-render animation on index change
          style={{
            width: `${activeIndex / testimonials.length * 100}%`
          }} data-id="element-305" />}
          </div>
        </div>
      </div>
    </section>;
}